// extracted by mini-css-extract-plugin
export default {"segmented":"VLSegmented_segmented__DV8lD"};